export interface Company {
  id: number
  name: string
  imageLink: string
  license: CompanyPlan
  employeeCount: number | undefined
  trustyTime: number | undefined
}

export enum CompanyPlan {
  PUR = 'PUR',
  PRO = 'PRO',
  PREMIUM = 'PREMIUM',
}
